import { createCrudSlice } from './createCrudSlice';
import { bathroomsApi } from '../../services/api';

const { reducer, actions } = createCrudSlice('bathrooms', bathroomsApi);

export const {
  fetchAll: fetchBathrooms,
  fetchById: fetchBathroomById,
  create: createBathroom,
  update: updateBathroom,
  remove: deleteBathroom,
  clearError,
  clearCurrentItem,
} = actions;

export default reducer;
